import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {Container, Message, Loader} from 'semantic-ui-react';

import {useHttpClient} from 'hooks';

import GitlabPagesSiteManagementForm from './GitlabPagesSiteManagementForm';

import styles from './GitlabPages.module.scss';

const GitlabPages = ({projectName}) => {
  const {data, error, loading: isLoadingGPSDetails, cancel, refetch} = useHttpClient({
    url: `/api/gps/${projectName}/gitlabpagessite`,
    method: 'GET',
  });

  useEffect(() => {
    return () => {
      cancel('Request cancelled since GitlabPagesSite has been unmounted.');
    };
  }, [cancel]);

  if (isLoadingGPSDetails) {
    return <Loader inline="centered" active />;
  } else if (error) {
    return (
      <Message error>
        There was a problem while fetching the details of the GitLab Pages site.
      </Message>
    );
  } else if (Object.keys(data.sites).length === 0) {
    return (
      <Message>
        <Message.Header>This GitLab Pages site is misconfigured.</Message.Header>
        <Message.Content>
          <p>
            There is no URL associated to this site and therefore it is not working. We recommend
            creating a new GitLab Pages site via the standard form.
          </p>
        </Message.Content>
      </Message>
    );
  }

  const [siteName, siteData] = Object.entries(data.sites)[0];

  return (
    <Container className={styles.GitlabPages}>
      <GitlabPagesSiteManagementForm
        siteName={siteName}
        siteData={siteData}
        projectName={projectName}
        refetch={refetch}
      />
    </Container>
  );
};

GitlabPages.propTypes = {
  projectName: PropTypes.string.isRequired,
};

export default GitlabPages;
